// utils/xmlSanitizedTextAreaAutosize.tsx
import React, { forwardRef } from "react";
import TextareaAutosize from "react-autosize-textarea";
import type { ChangeEvent } from "react";
import { withSanitizedOnChange } from "@/utils/xmlSanitizerOnChange";

type Props = React.ComponentProps<typeof TextareaAutosize>;

export const SanitizedTextareaAutosize = forwardRef<
HTMLTextAreaElement,
Props
>((props, ref) => {
  const { onChange, ...rest } = props;
  // wrap any consumer onChange through your sanitizer
  const sanitizedOnChange = withSanitizedOnChange(
    onChange as (e: ChangeEvent<HTMLTextAreaElement>) => void
  );

  return (
        <TextareaAutosize
            {...(rest as Props)}
            ref={ref}
            onChange={sanitizedOnChange}
        />
  );
});
